<span class="breadcrumb">
    <ng-container *ngFor="let item of breadcrumbItems; let i = index">
        {{ item.label }} <span *ngIf="i < breadcrumbItems.length - 1"> &nbsp;>&nbsp; </span>
    </ng-container>
</span>